import { __awaiter, __decorate, __extends, __generator } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ToggleContentLoader from "../../toggle-content";
var HolidayCheck = /** @class */ (function (_super) {
    __extends(HolidayCheck, _super);
    function HolidayCheck() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    HolidayCheck_1 = HolidayCheck;
    HolidayCheck.prototype.mounted = function () {
        this.holidaycheckContent = document.getElementById("holidaycheck_content");
        this.holidaycheckButton = document.getElementById("holidaycheck_button");
        this.holidaycheckPath = '';
        this.contentLoaded = false;
        if (this.holidaycheckContent) {
            this.holidaycheckPath = this.holidaycheckContent.getAttribute('data-holidaycheck-path');
        }
        var self = this;
        if (self.holidaycheckButton) {
            self.holidaycheckButton.addEventListener('click', function () {
                if (self.contentLoaded == false) {
                    self.loading = true;
                    HolidayCheck_1.loadHolidaycheckContent(self.holidaycheckPath).then(function (res) {
                        res.text().then(function (html) {
                            self.holidaycheckContent.innerHTML = html;
                            new ToggleContentLoader();
                            self.contentLoaded = true;
                            var holidaycheckSorting = document.getElementById("sortReviews");
                            holidaycheckSorting === null || holidaycheckSorting === void 0 ? void 0 : holidaycheckSorting.addEventListener('change', function () {
                                var holidaycheckSortedPath = self.holidaycheckPath + '/' + holidaycheckSorting.options[holidaycheckSorting.selectedIndex].value;
                                var holidaycheckReviewContent = document.getElementById("holidaycheckReviewContent");
                                HolidayCheck_1.loadHolidaycheckContent(holidaycheckSortedPath).then(function (res) {
                                    res.text().then(function (html) {
                                        var reviewsOnly = JSON.parse(html);
                                        holidaycheckReviewContent.innerHTML = reviewsOnly.html;
                                        new ToggleContentLoader();
                                    });
                                });
                            });
                        });
                    });
                }
            });
        }
    };
    HolidayCheck.loadHolidaycheckContent = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var HolidayCheck_1;
    HolidayCheck = HolidayCheck_1 = __decorate([
        Component({
            components: {}
        })
    ], HolidayCheck);
    return HolidayCheck;
}(Vue));
export default HolidayCheck;
